import { createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'

export const INITIAL_BASIC_LIST = {
  type: '',
  usedType: '',
  filterList1: [],
  usedFilter1: [],
}

export const INITIAL_FILTER_LIST = {
  ...INITIAL_BASIC_LIST,
  filterList2: [],
  usedFilter2: [],
  boxHeight: 40,
}

export const modalAddRegister = createSlice({
  name: 'filterSearch',
  initialState: {
    basicList: INITIAL_BASIC_LIST,
    filtersList: [INITIAL_FILTER_LIST],
    itemsAvailable: [],
    advancedSearch: false,
    advancedSearchUsed: false,
    filter: false,
    enable: false,
    filteredData: {
      type: 'FeatureCollection',
      features: [],
    },
    filteredCount: 0,
    lastFilterApplied: null,
    loadingFilters: false,
  },
  reducers: {
    setSearchByType: (state, action) => {
      state.basicList.type = action.payload
    },
    setTypeSearchUsed: (state, action) => {
      state.basicList.usedType = action.payload
    },
    basicListInitial: state => {
      state.basicList = INITIAL_BASIC_LIST
    },
    setSelectedList: (state, action) => {
      state.basicList.filterList1 = action.payload
    },
    setFiltersUsed: (state, action) => {
      state.basicList.usedFilter1 = action.payload
    },
    setFiltersList: (state, action) => {
      state.filtersList = action.payload
    },
    filterListInitial: state => {
      state.filtersList = [INITIAL_FILTER_LIST]
    },
    updateFilterListByID: (state, action) => {
      const { someId, someValue } = action.payload
      state.filtersList[someId] = someValue
    },
    setAdvancedSearch: (state, action) => {
      state.advancedSearch = action.payload
    },
    setAdvancedSearchUsed: (state, action) => {
      state.advancedSearchUsed = action.payload
    },
    setFilterState: (state, action) => {
      state.filter = action.payload
    },
    setANewFilterInList: (state, action) => {
      state.filtersList[action.payload + 1] = INITIAL_FILTER_LIST
    },
    removeFilterInList: (state, action) => {
      _.remove(state.filtersList, (n, i) => i === action.payload)
    },
    removeItemsAvailable: (state, action) => {
      _.remove(state.itemsAvailable, (n, i) => i === action.payload)
    },
    setBoxHeight: (state, action) => {
      const { someId, someValue } = action.payload
      state.filtersList[someId].boxHeight = someValue
    },
    setEnabledFilter: (state, action) => {
      state.enable = action.payload
    },
    setFilteredData: (state, action) => {
      state.filteredData = action.payload
      state.filteredCount = action.payload?.features?.length || 0
      state.loadingFilters = false
    },

    setLastFilterApplied: (state, action) => {
      state.lastFilterApplied = {
        filterData: action.payload,
        timestamp: new Date().toISOString(),
        count: state.filteredCount,
      }
    },

    setLoadingFilters: (state, action) => {
      state.loadingFilters = action.payload
    },

    clearFilteredData: state => {
      state.filteredData = {
        type: 'FeatureCollection',
        features: [],
      }
      state.filteredCount = 0
      state.lastFilterApplied = null
      state.loadingFilters = false
    },
    resetAllFilters: state => {
      state.basicList = INITIAL_BASIC_LIST
      state.filtersList = [INITIAL_FILTER_LIST]
      state.advancedSearch = false
      state.advancedSearchUsed = false
      state.filter = false
      state.enable = false
      state.filteredData = {
        type: 'FeatureCollection',
        features: [],
      }
      state.filteredCount = 0
      state.lastFilterApplied = null
      state.loadingFilters = false
    },
  },
})

export const {
  basicListInitial,
  setSearchByType,
  setTypeSearchUsed,
  setSelectedList,
  setFilterState,
  setFiltersUsed,
  setFiltersList,
  filterListInitial,
  updateFilterListByID,
  setAdvancedSearch,
  setAdvancedSearchUsed,
  setANewFilterInList,
  removeFilterInList,
  setBoxHeight,
  setEnabledFilter,
  setFilteredData,
  setLastFilterApplied,
  setLoadingFilters,
  clearFilteredData,
  resetAllFilters,
} = modalAddRegister.actions
export default modalAddRegister.reducer
